<div class="{{ className }}">
  <div class="{{ className }}__wrapper">
    @if (dataCategory.type === 0) {
      <breadcrumbs></breadcrumbs>
    }

    @if (isLoading || itemsList === undefined) {
      <skeleton-cards-list
        [title1]="categoryName"
        [title2]="categorySuggested['applications'].length > 0 ? 'Suggested Apps' : ''"
        [context]="context"></skeleton-cards-list>
    }
    @if (!isLoading && itemsList !== undefined) {
      <div class="{{ className }}__results-apps">
        <h3 class="{{ className }}__title">{{ categoryName }}</h3>
        @if (itemsList.length > 0) {
          <cards-list
            (refreshDataEmitter)="refreshData()"
            [itemsList]="itemsList"
            [theme]="theme"
            [isDesktop]="isDesktop"
            [width]="width"
            [dataCategory]="dataCategory"
            [categoryFeaturedId]="categoryFeaturedId"
            [categorySuggestedId]="categorySuggestedId"
            [categorySpecialId]="categorySpecialId"
            [categoryPurchasedId]="categoryPurchasedId"
            [categoryMostPurchasedId]="categoryMostPurchasedId"
            [categoryFeatured]="categoryFeatured"
            [categorySuggested]="categorySuggested"
            [categorySpecial]="categorySpecial"
            [categoryPurchased]="categoryPurchased"
            [categoryMostPurchased]="categoryMostPurchased"
            [context]="context"
            [title2]="categorySuggested['applications'].length > 0 ? 'Suggested Apps' : ''"
            [showButtons]="true"
            [showTagsList]="true"
            [showText]="showText"></cards-list>
        } @else {
          <app-empty
            (closeMenuEmitter)="closeMenu($event)"
            [img]="img"
            [title]="title"
            [itemsList]="[]"
            [description]="description"
            [buttonText]="buttonText"
            [buttonUrl]="buttonUrl"
            [theme]="theme"
            [isDesktop]="isDesktop"
            [width]="width"
            [categoryFeaturedId]="categoryFeaturedId"
            [categorySuggestedId]="categorySuggestedId"
            [categorySpecialId]="categorySpecialId"
            [categoryPurchasedId]="categoryPurchasedId"
            [categoryMostPurchasedId]="categoryMostPurchasedId"
            [categoryFeatured]="categoryFeatured"
            [categorySuggested]="categorySuggested"
            [categorySpecial]="categorySpecial"
            [categoryPurchased]="categoryPurchased"
            [categoryMostPurchased]="categoryMostPurchased"
            [context]="context"
            [title2]="categorySuggested['name'] ?? 'Suggested Apps'"
            [showButtons]="true"
            [showTagsList]="true"
            [showText]="showText"></app-empty>
        }
      </div>
    }
  </div>
</div>